import type { Transaction } from "../shared/types";
import { navigate } from "../shared/ui";
import { MemberTopBar } from "./MemberMobileUi";
import { isTransactionPaid } from "./transaction-settlement";
import { transactionPath } from "./transaction-groups";
import "./TransactionSettlement.css";

export function TransactionSettlementSteps({ transaction, stage }: {
  readonly transaction: Transaction;
  readonly stage: "payment" | "transfer";
}) {
  const paid = isTransactionPaid(transaction);
  const complete = transaction.status === "COMPLETED";
  const scheduled = transaction.status === "TRANSFER_READY" && transaction.transferScheduleType === "SCHEDULED";
  return <div className="settlement-step-group">
    <MemberTopBar title={stage === "payment" ? "카드 결제" : complete ? "완료" : scheduled ? "송금 예약" : "송금하기"}
      backTo={transactionPath(`/app/transactions/${transaction.id}`)} />
    <nav className="settlement-steps" aria-label="결제 후 송금 진행">
      <button type="button" aria-label="1 결제" aria-current={stage === "payment" ? "step" : undefined} data-completed={paid || undefined}
        onClick={() => navigate(transactionPath(`/app/transactions/${transaction.id}/payment`))}>
        <b aria-hidden="true">{paid ? "✓" : "1"}</b><span>결제</span>
      </button>
      <span className="settlement-step-line" aria-hidden="true" />
      <button type="button" aria-label="2 송금" aria-current={stage === "transfer" ? "step" : undefined} data-completed={complete || undefined}
        disabled={!paid} aria-describedby={!paid ? "settlement-step-help" : undefined}
        onClick={() => navigate(transactionPath(`/app/transactions/${transaction.id}/transfer`))}>
        <b aria-hidden="true">{complete ? "✓" : "2"}</b><span>송금</span>
      </button>
    </nav>
  </div>;
}

export function TransactionSettlementStepHelp() {
  return <p id="settlement-step-help" className="settlement-help">카드결제가 완료되면 송금 단계를 선택할 수 있어요.</p>;
}
